import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "react-emotion";

const StyledInput = styled("input")`
  width: ${({ size }) => {
    switch (size) {
      case "small":
        return "8em";
      case "large":
        return "15em";
      case "normal":
      default:
        return "10em";
    }
  }};
`;

export default class Input extends Component {
  static propTypes = {
    className: PropTypes.string,
    value: PropTypes.string,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    size: PropTypes.oneOf(["small", "normal", "large"]),
    validation: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    value: "",
    size: "normal"
  };

  handleChange = e => {
    let value = e.target.value;
    let isValid = true;
    if (this.props.validation) {
      isValid = this.props.validation(value);
    }
    if (
      isValid &&
      this.props.minLength &&
      this.props.minLength > value.length
    ) {
      isValid = false;
    }
    if (
      isValid &&
      this.props.maxLength &&
      (this.props.maxLength < 0 || this.props.maxLength < value.length)
    ) {
      isValid = false;
    }
    this.props.onChange(value, isValid);
  };

  render() {
    let classNames = ["upn-component-input"];
    if (this.props.className) {
      classNames.push(this.props.className);
    }
    return (
      <StyledInput
        type="text"
        className={classNames.join(" ")}
        value={this.props.value}
        placeholder={this.props.placeholder}
        onChange={val => this.handleChange(val)}
        disabled={this.props.disabled}
      />
    );
  }
}
